 
 import SockJS from 'sockjs-client';
 import Stomp from 'stompjs';

 var socket = null;
 //后台服务ip和porthttps://apitest.hooply.com
 //var url = 'https://chat.bianyl.xyz/api/ws/ep?token=';
//var url = 'http://127.0.0.1:8090/ws/ep?token=';
 var url = 'https://api.bianyl.xyz/ws/ep?token=';
 var global_callback = null;
 var stompClient = null;

function createConnection(callback,token){
    if (socket == null || typeof socket !== WebSocket) {
        connection(callback,token);
    } 
}


//创建连接
export const connection = (callback,token) => {
    
    if (process.env.NODE_ENV == "production") {
        //生产环境
       // url =  'https://api.bianyl.xyz/ws/ep?token=';
    }
    global_callback = callback;
    // 建立连接对象
    //连接服务端提供的通信接口，连接以后才可以订阅广播消息和个人消息
    socket = new SockJS(url+token);
    // 获取STOMP子协议的客户端对象
    stompClient = Stomp.over(socket);
}

//订阅
export const subscribe = (callback,token) => {
   
    createConnection(callback,token);
    stompClient.connect({}, success => {
        stompClient.subscribe('/user/queue/chat', msg => {
            console.log("msg:",msg)
            let receiveMsg = JSON.parse(msg.body);
            console.log("receiveMsg："+JSON.stringify(receiveMsg))
            global_callback(receiveMsg);
        
        })
    }, error => {
        global_callback(error);
    });
}

//发送消息
export const sendMsg = (msgObj) => {
    stompClient.send('/ws/chat', {}, JSON.stringify(msgObj));
}
//取消订阅
export const disSubscribe = () => {
    

    if(stompClient != null){
        if(stompClient.connected){
            stompClient.disconnect();
            stompClient = null;
            console.log("关闭stompClient")
        }
  
    }

}
//关闭连接
export const closeConnect = () => {
    if(socket != null){
        //if(socket.connected){
            socket.close();
            stompClient = null;
            console.log("关闭socket")
        //}
  
    }

}



//建立连接
/**
 *  function connection(callback) {
    if (socket == null || typeof socket !== WebSocket) {
        connection(callback);
    } 
    global_callback = callback;
    // 建立连接对象
    //连接服务端提供的通信接口，连接以后才可以订阅广播消息和个人消息
    socket = new SockJS(url);
    // 获取STOMP子协议的客户端对象
    stompClient = Stomp.over(socket);

}
 */
//订阅
/**
 * 
 * @param {*} msgObj 
 * function subscribe(callback){
    console.log("1111111")
    connection(callback);
    stompClient.connect({}, success => {
        stompClient.subscribe('/user/queue/chat', msg => {
            console.log("msg:",msg)
            let receiveMsg = JSON.parse(msg.body);
            console.log("receiveMsg："+JSON.stringify(receiveMsg))
            global_callback(msg);
        
        })
    }, error => {
        global_callback(error);
    });
}
 */
//发送消息
/**
 * function sendMsg(msgObj){
    stompClient.send('/ws/chat', {}, JSON.stringify(msgObj));
}
//取消订阅
function disSubscribe(){

    stompClient.disconnect();

}
 * 
 */